import { IMetaFormat } from '../../../../../../store/admin/roundFormats/store';
import { IFormats } from '../../AssignResults/Context/AssignResults.context';

export const getFormatsList = (adminRoundFormats: IMetaFormat[]) => {
  return !!adminRoundFormats.length
    ? adminRoundFormats.reduce(
        (formats: IFormats, roundFormat: IMetaFormat) =>
          formats[roundFormat.format.id]
            ? formats
            : { ...formats, [roundFormat.format.id]: roundFormat.format },
        {}
      )
    : {};
};
